import styled from 'styled-components'
//@ts-ignore
import makeCarousel from 'react-reveal/makeCarousel';
//@ts-ignore
import Slide from 'react-reveal/Slide';
import RightArrow from '../icons/rightArrow';
import LeftArrow from '../icons/leftArrow';
import { Close } from '../../../components/icons';
import Theme from '../../../Theme';
import { assetsPath, locations } from '../../../other/constants';
import Lottie from 'react-lottie'
import Button360 from '../../../assets/lottie/Button360.json'

const Container = styled.div`
    width: 100%;
    height: 30vh;
    min-height: 220px;
    position:relative;
    
    @media screen and  (max-height:${Theme.devices.mobile}) and (orientation:landscape) {
        height:100%;
        width:40%;
      }

    .react-reveal { 
        height: 100%;
        width: 100%;
    }
`
const Navigation = styled.div`
    position:absolute;
    left:38px;
    bottom:22px;
    width:14%;
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    z-index:3;
    cursor: pointer;
`
const View360Container = styled.div`
      position:absolute;
      right:20px;
      bottom:-60px;
      z-Index:3;
      width:120px;
      height:120px;
      cursor:pointer;
    
      span {
        position: absolute;
        right: -10px;
        left: -10px;
        top: calc(50% - 13px);
        position: absolute;
        background: #3A499C;
        padding: 6px;
        text-align: center;
        white-space: nowrap;
        font-style: normal;
        font-weight: bold;
        font-size: 13px;
        line-height: 15px;
        letter-spacing: 3.60045px;
        color: #FFFFFF;
        line-height: 1;
      }

    @media screen and  (max-width:${Theme.devices.mobile}) {
        bottom:-50px;
        right:5%;
        width:100px;
        height:100px;
    }
`
const CloseContainer = styled.div`
    position:absolute;
    right:20px;
    top:20px;
    z-Index:3;
    cursor:pointer;
    @media screen and  (max-height:${Theme.devices.mobile}) and (orientation:landscape) {
       top:5%;
       left:5%;

    }
`
const Image = styled.img`
    width:100%;
    object-fit: cover;
    height:100%;
`
//@ts-ignore
const Wrapper = ({ position, handleClick, children, closePopup, view3D, location, showArrows }) => {

    return (
        <Container className='fadeInDelayish' key={location}>
            <div style={{ overflow: "hidden", height: "100%", position: "relative" }}>
                {children}
            </div>
            {
                showArrows && <Navigation>
                    <div onClick={handleClick} data-position={position - 1} >
                        <LeftArrow />
                    </div>
                    <div onClick={handleClick} data-position={position + 1} >
                        <RightArrow />
                    </div>
                </Navigation>}
            { !!view3D &&

                <View360Container
                    onClick={view3D}
                    className='fadeInDelay'
                >
                    <Lottie
                        options={{
                            animationData: Button360,
                            loop: true,
                            autoplay: true,
                            rendererSettings: {
                                preserveAspectRatio: 'xMidYMid slice'
                            }
                        }} />
                    <span>
                        ENTER 360°
                    </span>
                </View360Container>
            }
            <CloseContainer onClick={closePopup}>
                <Close />
            </CloseContainer>
        </Container>
    )
}

const CarouselUI = makeCarousel(Wrapper)
type Props = {
    closePopup: () => void
    view3D?: () => void
    location: string
}

export default function Carousel({ closePopup, view3D, location }: Props) {
    //@ts-ignore
    const listOfImages = [...Array(locations[location].numberOfImgs).keys()]
    return (
        <CarouselUI
            showArrows={listOfImages.length > 1}
            location={location}
            defaultWait={listOfImages.length > 1 ? 3500 : 0}
            makeTurn={0}
            closePopup={closePopup}
            view3D={view3D}>
            { //@ts-ignore
                listOfImages.map((_, index) => (
                    <Slide right key={index} className='fadeInDelay'>
                        {/* @ts-ignore */}
                        {locations[location] && locations[location].imgDirectory && <Image src={`${assetsPath}${locations[location].imgDirectory}/${index + 1}.jpg`} />}
                    </Slide>
                ))
            }
        </CarouselUI>
    )
}
